/**
 * Grail27 — Trust confidence popup.
 * Product pages only. Fires once per browser session (sessionStorage).
 *
 * Triggers (after MIN_DELAY_MS on page):
 *   Desktop — exit intent (mouse leaves toward top), OR reviews section scrolls into view.
 *   Mobile  — scroll down until the bottom of related-products (“Curator’s Recommendations”).
 *
 * CTA "SECURE THIS MODEL": closes popup then clicks the PDP add-to-cart button only
 * (never related-product / collection card quick-add). Sold-out PDPs open Notify Me.
 */
(function () {
  var SESSION_KEY = 'grail_trust_popup_shown';
  var MIN_DELAY_MS = 20000;

  function shouldShow() {
    try { return !sessionStorage.getItem(SESSION_KEY); } catch (e) { return true; }
  }

  function markShown() {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
  }

  function fillJudgeReviewCount() {
    var line = document.querySelector('[data-grail-judge-line]');
    if (!line) return;

    var label = line.querySelector('[data-grail-judge-count-label]');
    if (!label) return;

    function applyCount(n) {
      var num = parseInt(String(n).replace(/[^\d]/g, ''), 10);
      if (!num || num < 1) return false;
      label.textContent = String(num);
      label.classList.remove('grail-trust-judge-count--pending');
      line.setAttribute('data-grail-judge-count', String(num));
      return true;
    }

    if (line.getAttribute('data-grail-judge-count')) {
      applyCount(line.getAttribute('data-grail-judge-count'));
    }

    function scrapeFromDom() {
      var nodes = document.querySelectorAll(
        '.jdgm-all-reviews-rating, .jdgm-all-reviews-text, .jdgm-rev-widg__summary-average, .jdgm-prev-badge__text, .jdgm-carousel__header, .jdgm-medals-wrapper, [data-number-of-reviews], [data-average-rating]'
      );
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var attr =
          el.getAttribute('data-number-of-reviews') ||
          el.getAttribute('data-number-of-reviews-formatted') ||
          el.getAttribute('data-total-reviews');
        if (attr && applyCount(attr)) return true;
        var text = (el.textContent || '').replace(/\s+/g, ' ');
        var m = text.match(/([\d,]+)\s+reviews?/i) || text.match(/\(([\d,]+)\)/);
        if (m && applyCount(m[1])) return true;
      }
      if (window.jdgmSettings && window.jdgmSettings.shop_reviews_count) {
        return applyCount(window.jdgmSettings.shop_reviews_count);
      }
      return false;
    }

    if (scrapeFromDom()) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (scrapeFromDom() || tries >= 20) clearInterval(timer);
    }, 500);
  }

  function init() {
    var popup    = document.getElementById('grail-trust-popup');
    var closeBtn = document.getElementById('grail-trust-popup-close');
    var ctaBtn   = document.getElementById('grail-trust-popup-cta');

    fillJudgeReviewCount();

    if (!popup || !shouldShow()) return;

    var opened = false;
    var pageReadyAt = Date.now();

    function delayElapsed() {
      return Date.now() - pageReadyAt >= MIN_DELAY_MS;
    }

    function open() {
      if (opened || !shouldShow() || !delayElapsed()) return;
      opened = true;
      markShown();
      cleanup();
      popup.style.display = 'grid';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          popup.classList.add('is-open');
          popup.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          var firstFocus = popup.querySelector('button, a');
          if (firstFocus) firstFocus.focus();
        });
      });
    }

    function close() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () {
        if (!popup.classList.contains('is-open')) popup.style.display = 'none';
      }, 260);
    }

    popup.addEventListener('click', function (e) {
      if (e.target === popup) close();
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        close();
        var soldOut = popup.getAttribute('data-grail-trust-soldout') === 'true';
        if (soldOut) {
          var notify = document.querySelector('[data-grail-notify-open]');
          if (notify) notify.click();
          return;
        }
        var btn = document.querySelector(
          '#GrailProductBuyCustom [name="add"]:not([disabled]), .grail-product-buy-custom .grail-atc-btn:not([disabled])'
        );
        if (btn) {
          btn.click();
          return;
        }
        var fallback = document.querySelector(
          '#GrailProductBuyCustom [name="add"], .grail-product-buy-custom .grail-atc-btn'
        );
        if (fallback) fallback.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var scrollOpts = { passive: true };
    var lastScrollY = window.scrollY;

    function onExitIntent(e) {
      if (e.clientY <= 5) open();
    }

    if (!isMobile) {
      document.addEventListener('mouseleave', onExitIntent);
    }

    function getReviewTrigger() {
      return document.querySelector(
        '[id*="17698456815ff0bcd7"], .jdgm-widget, #judgeme_product_reviews, .jdgm-rev-widg'
      );
    }

    /** Related-products block once Shopify recommendations have rendered cards. */
    function getSuggestedModelsEl() {
      var el = document.querySelector('product-recommendations.related-products');
      if (!el) return null;
      if (!el.querySelector('.product-grid .grid__item, ul.product-grid > li')) return null;
      return el;
    }

    /** True when user has scrolled down to the bottom of the suggestions grid. */
    function hasReachedSuggestedModelsEnd(scrollingDown) {
      if (!scrollingDown) return false;
      var el = getSuggestedModelsEl();
      if (!el) return false;
      var rect = el.getBoundingClientRect();
      var winH = window.innerHeight;
      return rect.top < winH && rect.bottom <= winH * 0.92;
    }

    function onScroll() {
      if (opened || !delayElapsed()) return;

      var scrollY = window.scrollY;
      var winH = window.innerHeight;
      var scrollingDown = scrollY > lastScrollY;
      lastScrollY = scrollY;

      if (isMobile) {
        if (hasReachedSuggestedModelsEnd(scrollingDown)) {
          open();
        }
        return;
      }

      var reviewEl = getReviewTrigger();
      if (reviewEl) {
        var rect = reviewEl.getBoundingClientRect();
        if (rect.top < winH * 0.80 && rect.bottom > 0) {
          open();
        }
      }
    }

    function cleanup() {
      document.removeEventListener('mouseleave', onExitIntent);
      window.removeEventListener('scroll', onScroll, scrollOpts);
    }

    window.addEventListener('scroll', onScroll, scrollOpts);
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(init, { timeout: 3000 });
  } else {
    setTimeout(init, 1);
  }
})();
